const topics = [
  { id: 1, title: '网红翻车实录', desc: '盘点近期翻车的大网红们，从带货翻车到人设崩塌全收录', count: 128, icon: 'ri-alert-line' },
  { id: 2, title: '明星恋情追踪', desc: '追踪娱乐圈最新恋情动态，甜蜜官宣到深夜密会全掌握', count: 96, icon: 'ri-heart-line' },
  { id: 3, title: '直播圈内幕', desc: '揭秘直播行业不为人知的背后故事与行业内幕爆料', count: 87, icon: 'ri-live-line' },
  { id: 4, title: '综艺争议现场', desc: '综艺节目争议名场面合集，剪辑黑幕与导师偏心全揭露', count: 74, icon: 'ri-tv-line' },
  { id: 5, title: '年度黑料盘点', desc: '按年度整理全网最具影响力的黑料事件，吃瓜必备合集', count: 65, icon: 'ri-calendar-check-line' },
  { id: 6, title: '品牌塌房记录', desc: '知名品牌翻车事件全记录，从虚假宣传到产品质量问题', count: 53, icon: 'ri-store-2-line' },
  { id: 7, title: '素人爆料精选', desc: '来自普通网友的真实爆料精选，最接地气的吃瓜内容', count: 41, icon: 'ri-user-voice-line' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              <i className="ri-compass-3-line"></i> 内容丰富
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              专题索引
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              七大专题方向，覆盖全网最热八卦事件，总有一款戳中你的吃瓜神经
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {topics.map((topic) => (
              <a
                key={topic.id}
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group bg-background-50 rounded-xl p-6 hover:bg-primary-50/50 transition-all duration-200 no-underline cursor-pointer"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${topic.icon} text-xl text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {topic.desc}
                </p>
                <span className="text-xs text-primary-500 font-medium">
                  {topic.count} 条相关内容
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}